export var isAsync = function (fn) {
  return fn.constructor.name === "AsyncFunction";
};